import React from "react";

export const More = () => {
  return (
    <div>
      <h1>More</h1>
    </div>
  );
};

export default More;
